import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IConfirmDialogData } from '../dialog.data';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.css']
})
export class ConfirmComponent {
  public dialogContentId: string = `mat-dialog-content-${parseInt(this.dialogRef.id.replace(/\D/g, ''), 10)}`;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IConfirmDialogData,
    private dialogRef: MatDialogRef<ConfirmComponent>
  ) {
    dialogRef._containerInstance._config.ariaDescribedBy = this.dialogContentId;
  }

}
